import {
  acquireDraftOwnership,
  type DraftOwnershipLease,
} from '@app/save/recovery-ownership';

/**
 * 既存ノートを開き始めてから NoteSaver が起動するまでの ownership 引継ぎ。
 * GET / draft復旧の await より前に取得し、成功時は同じ lease をそのまま saver へ渡す。
 */
export interface EditorOpenOwnership {
  takeForSaver(): DraftOwnershipLease;
  cancel(): void;
}

export function beginEditorOpenOwnership(noteId: string): EditorOpenOwnership {
  let lease: DraftOwnershipLease | null = acquireDraftOwnership(noteId);

  return {
    takeForSaver(): DraftOwnershipLease {
      if (!lease) throw new Error('editor ownership は既に引継ぎまたは解放されています');
      const taken = lease;
      lease = null;
      return taken;
    },
    cancel(): void {
      lease?.release();
      lease = null;
    },
  };
}
